// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_OrganisationEventModel from '../../model/tdg-organisation-event-model';
import Tdg_OrganisationEventDTO from '../dto/tdg-organisation-event-dto';
import dtoSchema from '../schemas/tdg-organisation-event-schema';

export default abstract class Tdg_OrganisationEventModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_OrganisationEventDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.creatorId = data.creatorId;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modified = data.modified ?? undefined;
      this.organisationId = data.organisationId;
      this.eventId = data.eventId;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {int64}
  */
  organisationId?: number;
  /**
  * @type {int64}
  */
  eventId?: number;

  static toModel(dto: DeepPartial<Tdg_OrganisationEventDTO>): Tdg_OrganisationEventModel;
  static toModel(dto: DeepPartial<Tdg_OrganisationEventDTO> | undefined | null): Tdg_OrganisationEventModel | undefined;
  static toModel(dto: DeepPartial<Tdg_OrganisationEventDTO> | undefined | null): Tdg_OrganisationEventModel | undefined {
    return dto ? new Tdg_OrganisationEventModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_OrganisationEventModel> | Tdg_OrganisationEventModel): Tdg_OrganisationEventDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      creatorId: unwrapped.creatorId,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modified: unwrapped.modified,
      organisationId: unwrapped.organisationId,
      eventId: unwrapped.eventId,
    } as Tdg_OrganisationEventDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_OrganisationEventModel, can not map to Tdg_OrganisationEventDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
